export enum Alert {
  DISABLE = 'DISABLE',
  WARNING = 'WARNING',
  TEST_BLOCK = 'TEST_BLOCK'
}
